import { Button } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { Link, useLocation } from '@remix-run/react';
import { DESIGN_BOARD_HOME_LINK } from '~/modules/design-board/config/design-board-config';
import * as S from './FilterBarBoardPinSwitchButton.style';

const FilterBarBoardPinSwitchButton = () => {
    const location = useLocation();
    const allPinsRoute = `${DESIGN_BOARD_HOME_LINK}/pins`;
    const isAllPins = location.pathname.includes(allPinsRoute);
    const { css } = useStyles({ activeButtonFirst: !isAllPins });

    return (
        <div className={css(S.SwitchButton)}>
            <Button
                color="dark"
                size={24}
                variables={{
                    buttonPadding: 16,
                    iconPadding: 4,
                }}
                variant="outlined"
                as={Link}
                to={DESIGN_BOARD_HOME_LINK}
                prefetch="intent"
                className={isAllPins ? 'inactive' : 'active'}
            >
                Boards
            </Button>

            <Button
                color="dark"
                size={24}
                variables={{
                    buttonPadding: 16,
                    iconPadding: 4,
                }}
                variant="outlined"
                as={Link}
                to={allPinsRoute}
                prefetch="intent"
                className={isAllPins ? 'active' : 'inactive'}
            >
                Pins
            </Button>
        </div>
    );
};

export default FilterBarBoardPinSwitchButton;
